import { userActions } from "../actions";

export function handleError(code) {
  console.log("handle error, code: ");
  console.log(code);
  if (code == 401 || code === 403 || code === 402) {
    userActions.logout();
    window.location.reload(true);
  }
}

export function handleResponse(response) {
  console.log("((((((((((((((((((((( handleResponse )))))))))))))))))))");
  if (response.status === 200) {
    if (response.data.success) {
      return response.data;
    }
    console.log("success: false", response);
    return response.data;
  }
  console.log("errrrroooooorrrrr");
  return { error: "true" };
  // const error = (result && result.message) || response.statusText;
  // return Promise.reject(error);
  // return response;
}

export function camelCase(str) {
  return str.substring(0, 1).toUpperCase() + str.substring(1);
}

export function formatNumber3By3(e, isReturn = false) {
  let { target: input, ...props } = e;
  var nStr = input.value + "";
  nStr = nStr.replace(/\,/g, "");
  var x = nStr.split(".");
  var x1 = x[0];
  var x2 = x.length > 1 ? "." + x[1] : "";
  var rgx = /([۰۱۲۳۴۵۶۷۸۹0-9]+)([۰۱۲۳۴۵۶۷۸۹0-9]{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  if (isReturn) {
    return (input.value = x1 + x2);
  } else input.value = x1 + x2;
}
